import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TagWrapper } from './tag.style';
import Icon from '../Icon';
function Tag(_a) {
  var {
      className = 'tags',
      label,
      icon,
      showClose,
      width = 'auto',
      fit = 'medium',
      variant = 'default',
      trailingicon,
      onClose
    } = _a,
    rest = __rest(_a, ["className", "label", "icon", "showClose", "width", "fit", "variant", "trailingicon", "onClose"]);
  return _jsxs(TagWrapper, _extends({
    className: className,
    width: width,
    fit: fit,
    variant: variant
  }, rest, {
    children: [icon && _jsx(Icon, {
      name: icon,
      size: fit === 'large' ? '24' : '20'
    }), _jsx("span", {
      children: label
    }), trailingicon && _jsx("button", _extends({
      title: "".concat(label, " close"),
      onClick: onClose
    }, {
      children: _jsx(Icon, {
        name: trailingicon,
        size: fit === 'large' ? '24' : '20'
      })
    })), showClose && _jsx("button", _extends({
      title: "".concat(label, " close"),
      onClick: onClose
    }, {
      children: _jsx(Icon, {
        name: "times",
        size: fit === 'large' ? '24' : '20'
      })
    }))]
  }));
}
export default Tag;